import { http } from "@/utils/http";

/** 登录 */
export const userLogin = data => {
  return http.request("post", "/biz/user/auth/login", { data });
};

export const loginVendor = data => {
  return http.request("post", "/biz/user/auth/loginVendor", { data });
};

export const loginMerchant = data => {
  return http.request("post", "/biz/user/auth/loginMerchant", { data });
};

export const loginUniverse = data => {
  return http.request("post", "/biz/user/auth/loginUniverse", { data });
};

/** 刷新token */
export const refreshTokenApi = data => {
  return http.request("post", "/refreshToken", { data });
};

/** 获取登录用户 */
export const getUser = () => {
  return http.request("get", "/biz/user/auth/get");
};

export const loginByToken = async data => {
  return http.request("post", "biz/user/auth/loginByToken", { data });
};

/**
 * 获取验证码
 * data： { "email" : "xx@cc.com"}
 */
export const requestRegister = data => {
  return http.request("post", "/biz/user/auth/password/requestRegister", {
    data
  });
};

export const register = data => {
  return http.request("post", "/biz/user/auth/password/register", { data });
};

export const requestResetPassword = data => {
  return http.request("post", "/biz/user/auth/password/requestResetPassword", {
    data
  });
};

export const userLogout = data => {
  return http.request("post", "/biz/user/auth/logout", {
    data
  });
};

/**
 * 忘记验证码
 * @param {*} data {"captcha" : "905835", "email" : "80932158@qq.com", "password" : "2"}
 * @returns
 */
export const resetPassword = data => {
  return http.request("post", "/biz/user/auth/password/resetPassword", {
    data
  });
};

/**
 * 忘记验证码
 * @param {*} data {"captcha" : "905835", "email" : "80932158@qq.com", "password" : "2"}
 * @returns
 */
export const validateEmailCaptcha = data => {
  return http.request("post", "/biz/util/validateEmailCaptcha", {
    data
  });
};

/**
 * 记录邀请码绑定关系
 * @param invitationCode
 * @returns
 */
export const logInviter = data => {
  return http.request("post", "/biz/user/usage/invitation/logInviter", {
    data
  });
};

/**
 * 获取用户列表
 * @returns
 */
export const getUsers = params => {
  return http.request("get", "/rest/users", {
    params
  });
};

/**
 * 更新用户开关
 * @param toggles
 * @returns
 */
export const updateUserToggles = toggles => {
  return http.request("post", "biz/user/toggle/update", {
    data: {
      toggles
    }
  });
};

export const singaporeAirlinesExtension = async (
  type = "ks",
  extensionParameter
) => {
  const query = {
    item: "luckyDraw",
    extensionFunction: "getInfo"
  };
  if (type == "jal") {
    query.activity = "y20241218JALMatch";
  } else {
    query.activity = "y20230409SigMatchSg";
  }
  if (extensionParameter) {
    query.extensionFunction = "submitInfo";
    query.extensionParameter = extensionParameter;
  }
  const res = await http.post("/biz/activity/extension", { data: query });
  return res;
};

export const convertCurrencies = async currency => {
  const postData = [
    {
      currency,
      amount: 1,
      targetCurrencies: [
        "CNY",
        "USD",
        "SGD",
        "EUR",
        "JPY",
        "HKD",
        "KRW",
        "AUD",
        "MYR",
        "IDR",
        "THB"
      ]
    }
  ];
  const res = await http.post("/biz/util/convertCurrencies", {
    data: postData
  });
  const mergeData = {};
  res.results.forEach(item => {
    mergeData[item.local.currency] = item;
  });
  return mergeData;
};
